export { default as CreacionSalida } from "./CreacionSalida";

